import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { FlexColumn, List } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { ViewWalletPortfolioValue, ViewWalletPortfolioValueSkeleton } from "../../ViewWalletPortfolioValue";
import { ViewWalletPortfolioValueFragment } from "../../ViewWalletPortfolioValue.fragment";
import { ProfileCollectionItem, ProfileCollectionItemSkeleton } from "./ProfileCollectionItem";
import { ProfileCollectionItemFragment } from "./ProfileCollectionItem.fragment";
export const NftTabQuery = graphql(`
    query NftTabQuery($address: Address!, $cursor: String, $limit: Int) {
      profileByAddress(address: $address) {
        __typename
        ... on Profile {
          portfolioSummary {
            estimatedNftValue {
              ...ViewWalletPortfolioValue
            }
          }
        }
      }

      profileCollections(
        addresses: [$address]
        cursor: $cursor
        limit: $limit
      ) {
        items {
          collection {
            id
            ...ProfileCollectionItem
          }
          ownership {
            itemCount
          }
        }
      }
    }
  `, [ViewWalletPortfolioValueFragment, ProfileCollectionItemFragment]);
export function NftTab(t0) {
  const $ = _c(16);
  const {
    address
  } = t0;
  const t = useTranslations("wallet.NftTab");
  let t1;
  if ($[0] !== address) {
    t1 = {
      query: NftTabQuery,
      variables: {
        address
      }
    };
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [t2] = useQuery(t1);
  const {
    data
  } = t2;
  if (!data?.profileByAddress || data.profileByAddress.__typename !== "Profile") {
    let t3;
    if ($[2] !== t) {
      t3 = t("errorMessage");
      $[2] = t;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t3) {
      t4 = <>{t3}</>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  const profileCollections = data.profileCollections.items;
  let t3;
  if ($[6] !== data.profileByAddress.portfolioSummary.estimatedNftValue) {
    t3 = <ViewWalletPortfolioValue className="px-2" portfolioValue={data.profileByAddress.portfolioSummary.estimatedNftValue} />;
    $[6] = data.profileByAddress.portfolioSummary.estimatedNftValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ManageInProfileButton />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== profileCollections) {
    t5 = profileCollections.map(_temp);
    $[9] = profileCollections;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <List className="*:!rounded-md bg-transparent pb-8" showBorder={false}>{t5}</List>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <FlexColumn className="gap-6 px-2 lg:px-4">{t3}{t4}{t6}</FlexColumn>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(t0) {
  const {
    collection,
    ownership
  } = t0;
  return <ProfileCollectionItem collection={collection} itemCount={ownership.itemCount} key={collection.id} />;
}
const ManageInProfileButton = () => {
  const $ = _c(4);
  const t = useTranslations("wallet.NftTab");
  let t0;
  if ($[0] !== t) {
    t0 = t("manageInProfile");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Button className="mx-2" href="/profile" variant="secondary">{t0}</Button>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export function NftTabSkeleton(t0) {
  const $ = _c(6);
  const {
    items: t1
  } = t0;
  const items = t1 === undefined ? 5 : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ViewWalletPortfolioValueSkeleton />;
    t3 = <ManageInProfileButton />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== items) {
    t4 = new Array(items).fill(0).map(_temp2);
    $[2] = items;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <FlexColumn className="gap-6 px-2 lg:px-4">{t2}{t3}<List className="*:!rounded-md bg-transparent" showBorder={false}>{t4}</List></FlexColumn>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp2(_, i) {
  return <ProfileCollectionItemSkeleton key={i} />;
}